import { render, staticRenderFns } from "./OrderBarrelFormProgress.vue?vue&type=template&id=3fa2c1f2&scoped=true&"
import script from "./OrderBarrelFormProgress.vue?vue&type=script&lang=js&"
export * from "./OrderBarrelFormProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2c1f2",
  null
  
)

export default component.exports